export default "__VITE_ASSET__BiJQzNi0__"